import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "flex flex-col md:flex-row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M241.935 35.5685H113.102C108.442 35.5685 104.66 30.5973 104.66 24.4556C104.66 18.3139 108.442 13.3428 113.102 13.3428H241.935C246.595 13.3428 250.377 18.3139 250.377 24.4556C250.377 30.5973 246.595 35.5685 241.935 35.5685ZM250.377 105.461C250.377 99.3265 246.595 94.3479 241.935 94.3479H113.102C108.442 94.3479 104.66 99.3265 104.66 105.461C104.66 111.595 108.442 116.574 113.102 116.574H241.935C246.595 116.574 250.377 111.595 250.377 105.461ZM200.473 64.9656C200.473 58.8239 196.691 53.8528 192.031 53.8528H8.44214C3.78208 53.8528 0 58.8239 0 64.9656C0 71.1073 3.78208 76.0784 8.44214 76.0784H192.025C196.691 76.0784 200.473 71.0999 200.473 64.9656ZM427.026 131.628C428.951 131.583 445.987 131.161 451.981 130.05C491.963 122.738 539.599 105.616 539.599 65.5805C539.588 26.1522 491.89 8.99398 451.902 1.54838C446.156 0.466736 429.289 0.0444513 427.234 0H271.392C266.732 0 262.95 4.97114 262.95 11.1128V120.411C262.95 126.545 266.727 131.524 271.387 131.524L426.863 131.635C426.919 131.628 426.97 131.628 427.026 131.628ZM279.835 22.2183H427.077C433.87 22.3738 445.954 22.8776 449.51 23.5518C493.28 31.7012 522.698 48.5927 522.709 65.5805C522.709 82.9758 493.348 100.038 449.64 108.039C445.875 108.735 433.949 109.232 426.79 109.402L279.835 109.298V22.2183Z",
  fill: "white"
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col self-center" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-white text-lg font-normal" }, "Reset your password")
], -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "text-white text-base font-normal mt-10 mb-3 mx-20" }
const _hoisted_8 = { class: "text-red-500 font-light ml-4" }
const _hoisted_9 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock("svg", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
        class: "md:ml-20 md:mx-0 mx-auto cursor-pointer",
        id: "logo",
        width: "200",
        height: "132",
        viewBox: "0 0 600 132",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, _hoisted_4)),
      _hoisted_5
    ]),
    _createElementVNode("h1", {
      class: _normalizeClass([{
              'text-green-500': _ctx.status === 'Successfully sent reset password request.',
              'text-red-500': _ctx.status !== 'Successfully sent reset password request.',
            }, "text-white text-xl mb-5 mt-10 mx-20 font-light"])
    }, [
      _createTextVNode(_toDisplayString(_ctx.status) + " ", 1),
      (_ctx.status === 'Successfully sent reset password request.')
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, "If a user exists with the username/email provided, an email will arrive shortly."))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("h1", _hoisted_7, [
      _createTextVNode(" Username/Email "),
      _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.error), 1)
    ]),
    _createElementVNode("input", {
      onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onUserInput && _ctx.onUserInput(...args))),
      value: _ctx.username,
      class: "mx-20 px-3 py-3 placeholder-gray-400 relative bg-Third text-white rounded text-sm focus:ring-Secondary focus:ring-2 border-0",
      type: "text",
      placeholder: "Enter your username/email"
    }, null, 40, _hoisted_9),
    _createElementVNode("button", {
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args))),
      class: "text-white text-base font-light py-3 mt-20 bg-Third mx-20 rounded",
      id: "submit"
    }, " Send ")
  ]))
}